import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

/**
 * EventDetails - Displays event metadata (type, description, timestamp, location, etc.)
 * @param {boolean} isMatchEvent - Whether this is a match event
 * @param {boolean} isNoteEvent - Whether this is a note event
 * @param {string} eventLabel - Event type label
 * @param {string} description - Event description
 * @param {string} dateTimeStr - Formatted date/time string
 * @param {string} matchSource - Match source ('face_match' or 'human_match')
 * @param {string} systemNote - System-generated note
 * @param {Object} location - Location object with latitude/longitude
 */
export default function EventDetails({
  isMatchEvent,
  isNoteEvent,
  eventLabel,
  description,
  dateTimeStr,
  matchSource,
  systemNote,
  location
}) {
  return (
    <>
      {!isMatchEvent && !isNoteEvent && (
        <>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            <strong>Type:</strong> {eventLabel}
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            <strong>Description:</strong>
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, pl: 2 }}>
            {description}
          </Typography>
        </>
      )}
      {isNoteEvent && (
        <>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            <strong>Type:</strong> {eventLabel}{' '}
            {!systemNote && (
              <Typography component="span" variant="caption" color="warning.main">
                (Legacy Format)
              </Typography>
            )}
          </Typography>
          {description && (
            <>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>Description:</strong>
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, pl: 2 }}>
                {description}
              </Typography>
            </>
          )}
        </>
      )}
      <Typography variant="body2" color="text.secondary">
        <strong>Created:</strong> {dateTimeStr}
      </Typography>
      {isMatchEvent && matchSource && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          <strong>Source:</strong> {matchSource === 'face_match' ? 'AI Match' : 'Human Match'}
        </Typography>
      )}
      {systemNote && (
        <Box
          sx={{
            mt: 1,
            p: 1,
            backgroundColor: 'rgba(25, 118, 210, 0.08)',
            borderRadius: 1,
            borderLeft: '3px solid rgba(25, 118, 210, 0.5)'
          }}
        >
          <Typography variant="body2" color="primary" sx={{ fontStyle: 'italic' }}>
            {systemNote}
          </Typography>
        </Box>
      )}
      {location && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          <strong>Location:</strong> {location.latitude.toFixed(6)}, {location.longitude.toFixed(6)}
        </Typography>
      )}
    </>
  );
}
